  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import IconButton                                          from '@material-ui/core/IconButton';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
//import ListItemText                                        from '@material-ui/core/ListItemText';
//import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
//import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';
  //----------------
  // core components
  //----------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
//import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_BillsService }                                 from "../../_services";
//import { wu_CountriesStatesCitiesService }                 from "../../_services";
//import { wu_CurrenciesService }                            from "../../_services";
  //------
  // Style
  //------
  import BillsCompaniesStyle                                 from "./BillsCompaniesStyle.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import wu_bills_grayArrow                                  from "assets/img/wu/wu_bills_grayArrow.svg";

  //header menu Images
  import Bills_header_home                                   from "assets/img/wu/Bills_header_home.svg";
  import Bills_header_categories                             from "assets/img/wu/Bills_header_categories.svg";
  import Bills_header_history                                from "assets/img/wu/Bills_header_history.svg";
  import Bills_header_favorites                              from "assets/img/wu/Bills_header_favorites.svg";
//import Bills_header_scan                                   from "assets/img/wu/Bills_header_scan.svg";

  import SearchIcon                                          from "@material-ui/icons/Search";
  //----------
  // variables
  //----------
  const filename = "BillsCompanies ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  //header menu - Autocomplete
  const AUTOCOMPLETE_MIN_CHARACTERS_OPEN_POPUP = 1000;    //
  const AUTOCOMPLETE_FILTER_OPTIONS            = "start"; //"start","any"
  const AUTOCOMPLETE_KEYWORDS_LANG_ALL         = true;    //true=greek and english together
  const AUTOCOMPLETE_KEYWORDS_KEYS_ALL         = ["nameEl","nameEn",];

class BillsCompanies extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      parserObject_categoriesList                          : [],
      parserObject_companiesList                           : [],

      //header menu - state
      Bills_header_home                                    : Bills_header_home,
      Bills_header_categories                              : Bills_header_categories,
      Bills_header_history                                 : Bills_header_history,
      Bills_header_favorites                               : Bills_header_favorites,
    //Bills_header_scan                                    : Bills_header_scan,

      autoCompleteSearchEnabled                            : api.autoCompleteSearchEnabled, //newSearchEnabled
      textField1                                           : "",
      textField1_inputValue                                : "",
      textField1_hasError                                  : false,
      textField1_popoverOpen                               : false,

      canSearchRF                                          : false,
      searchResults_isHidden                               : true,
      searchResults_arr                                    : true,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //header menu - bindings
    this.handleCustomDropDownClick_headerMenu_change                 = this.handleCustomDropDownClick_headerMenu_change.bind(this);
    this.handleCustomDropDownClick_headerMenu_close                  = this.handleCustomDropDownClick_headerMenu_close.bind(this);
    this.headerMenu_btn_search_isDisabled                            = this.headerMenu_btn_search_isDisabled.bind(this);
    this.headerMenu_btn_search_with_enter                            = this.headerMenu_btn_search_with_enter.bind(this);
    this.headerMenu_btn_search_with_icon                             = this.headerMenu_btn_search_with_icon.bind(this);
    this.headerMenu_btn_search_logic                                 = this.headerMenu_btn_search_logic.bind(this);
    this.Bills_header_scan_act                                       = this.Bills_header_scan_act.bind(this);
    this.Bills_header_home_act                                       = this.Bills_header_home_act.bind(this);
    this.Bills_header_categories_act                                 = this.Bills_header_categories_act.bind(this);
    this.Bills_header_history_act                                    = this.Bills_header_history_act.bind(this);
    this.Bills_header_favorites_act                                  = this.Bills_header_favorites_act.bind(this);

    this.onListItemClick_company                                     = this.onListItemClick_company.bind(this);

    this.get_companyName_FromObj                                     = this.get_companyName_FromObj.bind(this);

    this.process_CategoriesCompaniesObject                           = this.process_CategoriesCompaniesObject.bind(this);
    this.process_CompaniesObject                                     = this.process_CompaniesObject.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    //if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }

    //localStorage.setItem("accessToken", "bad717b8-e102-408f-97b0-9f8aefed26d2");
    //let shouldForceRefreshAccessToken = wu_Utilities.shouldForceRefreshAccessToken();
    //if(api.print_logs){console.log('cookie='+Cookies.get('testCookie'));}

    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}

    //-------------------------
    //wu_getCategoriesCompanies---CACHED
    //-------------------------
    let retrieveWSData_getCategoriesCompanies = wu_BillsService.wu_should_getCategoriesCompanies();
    if(api.print_logs){console.log("retrieveWSData_getCategoriesCompanies="+retrieveWSData_getCategoriesCompanies);}
    if(retrieveWSData_getCategoriesCompanies){
      wu_BillsService
      .wu_getCategoriesCompanies({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="BillsCompanies"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn();
      })
      .catch(err => {
        console.log(methName+"err="+err);
      });
    }
    else{
      try{
        //let res = JSON.parse(localStorage.getItem("categoriescompanies"));
        this.process_CategoriesCompaniesObject();
        this.makeHTTPConn();
      }catch(err){
        console.log(methName+'err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn() {
    let methName = filename+"makeHTTPConn ";
    if(api.print_logs){console.log(methName);}

    //header menu - Keywords
    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}
    let getLocations_keywords_vals_all = wu_Utilities.extractKeywordsFromJSON(parserObject_categoriesCompaniesList,AUTOCOMPLETE_KEYWORDS_KEYS_ALL);
    //console.log(methName+'getLocations_keywords_vals_all='+getLocations_keywords_vals_all.length+'=>'+getLocations_keywords_vals_all);
    this.setState({ "getLocations_keywords_vals_all": getLocations_keywords_vals_all });

    this.process_CompaniesObject();
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    let defaultPropsCountry = {};
    if(AUTOCOMPLETE_KEYWORDS_LANG_ALL===true){
      defaultPropsCountry = { options:this.state.getLocations_keywords_vals_all, getOptionLabel:option => option, };
    }
    else{
      defaultPropsCountry = { options:localStorage.getItem("lang")==="en" ? this.state.getLocations_keywords_vals_en : this.state.getLocations_keywords_vals_el, getOptionLabel:option => option, };
    }
    const filterOptions = createFilterOptions({
      matchFrom: AUTOCOMPLETE_FILTER_OPTIONS,
      stringify: option => option,
    });

    let labelHeader = (localStorage.getItem("lang")==="en") ? localStorage.getItem("parserObject_companiesList_ws_category_en") : localStorage.getItem("parserObject_companiesList_ws_category_el");

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={api.columns_bills_sm} md={api.columns_bills_md}>

            <GridContainer justify="center">
              <GridItem xs={2} sm={2} md={1}>
                <div style={{ marginTop:10,marginBottom:10, textAlign:"left" }}>
                  {/* ----------[goBack]------------ */}
                  {/* <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button> */}
                </div>
              </GridItem>
              {/* <GridItem xs={10} sm={10} md={11}>
                <div style={{ marginTop: 25 }}>
                  <div className={classes.labelHeader}>{this.NSInforString("BillsCompanies_title")}</div>
                  <div className={classes.logo}><img src={logo} alt="logo" /></div>
                </div>
              </GridItem> */}
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* -------------------------------- */}
            {/* ----------[//Header Menu]------- */}
            {/* -------------------------------- */}
            <div style={{ padding:5, marginTop:10, textAlign : "center",backgroundColor:"#FFFFFF", "border-radius": "10px"}}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={6} style={{position:"relative", "border-radius": "10px", border:"1px dotted gray"}}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl fullWidth className={classes.picker1_textFieldLabel1}>
                        <div className={classes.HeaderMenuSearchLabel}>{this.NSInforString("BillsCompanies_lbl_searchBar_label")}</div>
                        <Autocomplete
                          id="textField1_autocomplete"
                          onKeyPress={this.headerMenu_btn_search_with_enter}
                          freeSolo
                          filterOptions={filterOptions}
                          {...defaultPropsCountry}
                          value={this.state.textField1}
                          inputValue={this.state.textField1_inputValue}
                          open={this.state.textField1_popoverOpen}
                          onClose={(event,value) => this.handleCustomDropDownClick_headerMenu_close(event,value)}
                          onInputChange={(event,value) => this.handleCustomDropDownClick_headerMenu_change(event,value)}
                          renderOption={option => {return (<React.Fragment>{option}</React.Fragment>);}}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={this.state.textField1_hasError}
                              label={this.NSInforString("BillsCompanies_lbl_searchBar_plh")}
                              margin="normal"
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <React.Fragment>
                                    <IconButton onClick={this.headerMenu_btn_search_with_icon} onMouseDown={this.headerMenu_btn_search_with_icon} size="small">
                                      <SearchIcon />
                                    </IconButton>
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </GridItem>
                    {/*<GridItem xs={3} sm={3} md={3}>
                    <div style={{width:"100%", display:"inline-block", marginTop:20, textAlign:"center",}}>
                      <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_scan")}</div>
                      <Button onClick={this.Bills_header_scan_act}><div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_scan} alt=""/></div></Button>
                    </div>
                    </GridItem>*/}
                  </GridContainer>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{backgroundColor:"#F7F7F7", "border-radius": "10px"}}>
                  <div style={{width:"25%", display:"inline-block", marginTop:20}}>
                    <Button onClick={this.Bills_header_home_act}>
                    <div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_home} alt=""/></div>
                    </Button>
                    <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_home")}</div>
                  </div>

                  <div style={{width:"25%", display:"inline-block", marginTop:20}}>
                    <Button onClick={this.Bills_header_categories_act}>
                    <div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_categories} alt=""/></div>
                    </Button>
                    <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_categories")}</div>
                  </div>

                  <div style={{width:"25%", display:"inline-block", marginTop:20}}>
                    <Button onClick={this.Bills_header_history_act}>
                    <div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_history} alt=""/></div>
                    </Button>
                    <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_history")}</div>
                  </div>

                  <div style={{width:"25%", display:"inline-block", marginTop:20}}>
                    <Button onClick={this.Bills_header_favorites_act}>
                    <div className={classes.HeaderMenuImage}><img src={this.state.Bills_header_favorites} alt=""/></div>
                    </Button>
                    <div className={classes.HeaderMenuLabel}>{this.NSInforString("Bills_header_favorites")}</div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
            {/* -------------------------------- */}
            {/* ----------[yellow Header]------- */}
            {/* -------------------------------- */}
            <div style={{marginTop:20, marginBottom:20}}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 0 }}>
                    {/* <div className={classes.labelHeader}>{ this.NSInforString("BillsCompanies_title")}</div> */}
                    <div className={classes.labelHeader}>{ labelHeader }</div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
            {/* -------------------------------- */}
            {/* ----------[Items List]---------- */}
            {/* -------------------------------- */}
            {this.state.searchResults_isHidden === false ? ( "" ) : (
              <div style={{marginBottom:20}}>
                <List component="nav" aria-label="main mailbox folders">
                  {this.state.parserObject_companiesList.map(e => (
                    <React.Fragment key={"fragmentId_"+e.id}>
                      <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_company(e)}>
                        <GridContainer justify="center">
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>

                          <GridItem xs={10} sm={10} md={10}><div className={classes.listItem_fullName}>{this.get_companyName_FromObj(e)}</div></GridItem>
                          <GridItem xs={2} sm={2} md={2}><div style={{textAlign:"right"}}><img src={wu_bills_grayArrow} alt="wu_bills_grayArrow" /></div></GridItem>

                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                        </GridContainer>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </div>
            )}
            {/* -------------------------------- */}
            {/* ----------[Search Results]------ */}
            {/* -------------------------------- */}
            {this.state.searchResults_isHidden === true ? ( "" ) : (
              <div style={{marginBottom:20}}>
                <List component="nav" aria-label="main mailbox folders">
                  {this.state.searchResults_arr.map(e => (
                    <React.Fragment key={"fragmentIdSearchResults_"+e.id}>
                      <ListItem style={{ cursor: 'pointer' }} onClick={(e1) => this.onListItemClick_company(e)}>
                        <GridContainer justify="center">
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>

                          <GridItem xs={10} sm={10} md={10}><div className={classes.listItem_fullName}>{this.get_companyName_FromObj(e)}</div></GridItem>
                          <GridItem xs={2} sm={2} md={2}><div style={{textAlign:"right"}}><img src={wu_bills_grayArrow} alt="wu_bills_grayArrow" /></div></GridItem>

                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                          <GridItem xs={6} sm={6} md={6}><div className={classes.listItem_empty}></div></GridItem>
                        </GridContainer>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </div>
            )}
          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  onListItemClick_company(obj){
    let methName = filename+"onListItemClick_company ";
    if(api.print_logs){console.log(methName);}

    //var parserObject_categoriesCompaniesList = null;
    //try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    let ws_billId = obj.id;

    var parserObject_bills_payment_info_billPayment_req = {};
    parserObject_bills_payment_info_billPayment_req["billerId"] = ws_billId;
    localStorage.setItem("parserObject_bills_payment_info_billPayment_req", JSON.stringify(parserObject_bills_payment_info_billPayment_req));
    localStorage.setItem("bills_billerId", ws_billId+"");

    localStorage.setItem("billPaymentSetup_ws","billPayment");
    //+++++++++++++++++
    //BillsPaymentSetup
    //+++++++++++++++++
    localStorage.setItem("BillsPaymentSetup_prev_view","BillsCompanies");
    history.push(wu_Utilities.getNavigationURLs("BillsPaymentSetup"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //header menu - drop down
  handleCustomDropDownClick_headerMenu_change(event,value) {
    let methName = filename+"handleCustomDropDownClick_headerMenu_change ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}

    //console.log(methName+"["+eventTMP+"]");
    if(eventTMP.length>=AUTOCOMPLETE_MIN_CHARACTERS_OPEN_POPUP){
      this.setState({"textField1_inputValue":eventTMP});
      this.setState({"textField1_popoverOpen":true});
      this.setState({"textField1_hasError":false});
    }
    else{
      this.setState({"textField1_inputValue":eventTMP});
      this.setState({"textField1_popoverOpen":false});
      this.setState({"textField1_hasError":false});
    }
    if(eventTMP===""){
      this.setState({"searchResults_isHidden":true });
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_headerMenu_close(event,value) {
    let methName = filename+"handleCustomDropDownClick_headerMenu_close ";
    let event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
    let eventTMP = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    if(api.print_logs){console.log(methName+eventTMP);}

    this.setState({"textField1_popoverOpen":false});
    //document.getElementsByClassName('MuiAutocomplete-clearIndicator')[0].click();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //header menu
  Bills_header_scan_act(event) {
    let methName = filename+"Bills_header_scan_act ";
    if(api.print_logs){console.log(methName);}

    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    //history.push(wu_Utilities.getNavigationURLs("BillsScanner"));
  }
  //----------------------------------------------------------------------------------------------------
  Bills_header_home_act(event) {
    let methName = filename+"Bills_header_home_act ";
    if(api.print_logs){console.log(methName);}

    if(localStorage.getItem("curr_view").trim() !== "Bills"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("Bills"));
    }
    this.setState({
      "textField1_inputValue":"",
      "textField1_popoverOpen":false,
      "textField1_hasError":false,
      "searchResults_isHidden":true,
    });
  }
  //----------------------------------------------------------------------------------------------------
  Bills_header_categories_act(event) {
    let methName = filename+"Bills_header_categories_act ";
    if(api.print_logs){console.log(methName);}

    if(localStorage.getItem("curr_view").trim() !== "BillsCategories"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("BillsCategories"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  Bills_header_history_act(event) {
    let methName = filename+"Bills_header_history_act ";
    if(api.print_logs){console.log(methName);}

    if(localStorage.getItem("curr_view").trim() !== "BillsHistory"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("BillsHistory"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  Bills_header_favorites_act(event) {
    let methName = filename+"Bills_header_favorites_act ";
    if(api.print_logs){console.log(methName);}

    if(localStorage.getItem("curr_view").trim() !== "BillsFavorites"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("BillsFavorites"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  NSInforString_withLang(aKey,lang){
    if(lang==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else           { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  //----------------------------------------------------------------------------------------------------
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities CategoriesCompanies---------------------
  //----------------------------------------------------------------------------------------------------
  process_CategoriesCompaniesObject(){
    let methName = filename+"process_CategoriesCompaniesObject ";
    if(api.print_logs){console.log(methName);}

    let categoryFieldDescr = localStorage.getItem("lang")==="el" ? "categoryEl" : "categoryEn";
    var parserObject_categoriesList = [];
    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    for(var i=0; i<parserObject_categoriesCompaniesList.length; ++i){
       let aItem = parserObject_categoriesCompaniesList[i];
       let category   = "";
       var categoryEl = "";
       var categoryEn = "";
       var mid        = 0;
       try {category   = aItem[categoryFieldDescr]; }catch(err){;} if(category   === null || (typeof category   ==="undefined")){category   = "";}
       try {categoryEl = aItem["categoryEl"];       }catch(err){;} if(categoryEl === null || (typeof categoryEl ==="undefined")){categoryEl = "";}
       try {categoryEn = aItem["categoryEn"];       }catch(err){;} if(categoryEn === null || (typeof categoryEn ==="undefined")){categoryEn = "";}
       try {mid        = aItem["mid"];              }catch(err){;} if(mid        === null || (typeof mid        ==="undefined")){mid        = 0;}
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       if(wu_Utilities.bills_categoryExists(category, parserObject_categoriesList) === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = categoryEl;
           aCategory["categoryEn"] = categoryEn;
           aCategory["mid"]        = mid;
           parserObject_categoriesList.push(aCategory);
       }
    }

    parserObject_categoriesList.sort(function(a, b) {
      if( (a.category).localeCompare(b.category) === -1){ return -1; }
      if( (a.category).localeCompare(b.category) === 1){ return 1; }
      return 0;
    });

    var popularFound = false;
    for(var j=0; j<parserObject_categoriesCompaniesList.length; ++j){
       let aItem = parserObject_categoriesCompaniesList[j];
       if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aItem)===false){continue;}
       var popularity = 0;
       try {popularity = aItem["popularity"]; }catch(err){;} if(popularity === null || (typeof popularity ==="undefined")){popularity = 0;}
       let category = this.NSInforString("Bills_popular_category");
       if(popularity > 0 && popularFound === false){
           let aCategory = {};
           aCategory["category"]   = category;
           aCategory["categoryEl"] = this.NSInforString_withLang("Bills_popular_category","el");
           aCategory["categoryEn"] = this.NSInforString_withLang("Bills_popular_category","en");
           aCategory["mid"]        = 1000000;
           parserObject_categoriesList.splice(0, 0, aCategory);//insert at index 0
           popularFound = true;
       }
    }

    this.setState({ "parserObject_categoriesList" : parserObject_categoriesList });
  }
  //----------------------------------------------------------------------------------------------------
  process_CompaniesObject(){
    let methName = filename+"process_CompaniesObject ";
    if(api.print_logs){console.log(methName);}

    let parserObject_companiesList = [];
    try{ parserObject_companiesList = JSON.parse(localStorage.getItem("parserObject_companiesList"));}catch(err){console.log(methName+'err='+err);}
    console.log("parserObject_companiesList.length ="+this.state.parserObject_companiesList.length);

    this.setState({ "parserObject_companiesList": parserObject_companiesList });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities get data from Obj-----------------------
  //----------------------------------------------------------------------------------------------------
  get_companyName_FromObj(obj){
    if(obj){
      let fieldDescr = localStorage.getItem("lang")==="el" ? "nameEl" : "nameEn";
      return obj[fieldDescr];
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities headermenu------------------------------
  //----------------------------------------------------------------------------------------------------
  //header menu - Utilities
  headerMenu_btn_search_isDisabled(){
    //if(this.verifyLength(this.state.textField1,1)===false){ return true; } //mtcn
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  headerMenu_btn_search_with_enter(event){
    if (event.charCode === 13) { // enter key pressed
      event.preventDefault();
      this.setState({
      //"textField1"          : "",
        "textField1_hasError" : false,
        "dialogS_isOpen"      : false,
      });
      setTimeout(function() {
        this.headerMenu_btn_search_logic(event);
      }.bind(this), 100);
    }
    //let this_state_textField1 = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value : this.state.textField1;
    //console.log("headerMenu_btn_search_with_enter this_state_textField1="+this_state_textField1);
  }
  //----------------------------------------------------------------------------------------------------
  headerMenu_btn_search_with_icon(event){
    event.preventDefault();
    this.setState({
    //"textField1"          : "",
      "textField1_hasError" : false,
      "dialogS_isOpen"      : false,
    });
    setTimeout(function() {
      this.headerMenu_btn_search_logic(event);
    }.bind(this), 100);
    //let this_state_textField1 = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value : this.state.textField1;
    //console.log("headerMenu_btn_search_with_icon this_state_textField1="+this_state_textField1);
  }
  //----------------------------------------------------------------------------------------------------
  headerMenu_btn_search_logic(event) {
    let methName = filename+"headerMenu_btn_search_logic ";
    if(api.print_logs){console.log(methName);}

    var parserObject_categoriesCompaniesList = null;
    try{ parserObject_categoriesCompaniesList = (JSON.parse(localStorage.getItem("categoriescompanies"))).billers ;}catch(err){console.log(methName+'err='+err);}

    let keyword = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value : this.state.textField1;
    console.log(methName+"keyword="+keyword);
    if(keyword.toUpperCase().startsWith("RF") && this.state.canSearchRF){
      //this.makeHTTPConn_bills_info_inputSingleRF();
      return;
    }

    let pops_search_res = [];
    let this_state_textField1  = (this.state.autoCompleteSearchEnabled) ? document.getElementById("textField1_autocomplete").value  : this.state.textField1;
    let searchTerm             =  this_state_textField1.trim();
    let search_S = new Date();
    let search_E = new Date();
    console.log(methName+"this_state_textField1  = "+this_state_textField1);
    console.log(methName+"searchTerm             = "+searchTerm);

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this_state_textField1.trim() === ""){
        this.setState({"textField1_hasError"  : true }); emptyFields = true;
        if(emptyFields===true){return;}
      }
    }

    if(!parserObject_categoriesCompaniesList){
        this.dialog_handleOpen(this.NSInforString("BillsSearch_msg02"));
        return;
    }
    if(this_state_textField1 === ""){
        this.dialog_handleOpen(this.NSInforString("BillsSearch_msg01"));
        return;
    }

    let TextField1Text_NoTone   = wu_Utilities.replaceTonoumena(this_state_textField1.trim().toUpperCase());
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    TextField1Text_NoTone = TextField1Text_NoTone.replace("  ", " ");
    let TextField1Text_NoTone_arr = TextField1Text_NoTone.split(" ");

    search_S = new Date();
    pops_search_res = this.search_auxiliary(parserObject_categoriesCompaniesList,TextField1Text_NoTone_arr[0]);
    for (let j=0; j<TextField1Text_NoTone_arr.length; ++j) {
        pops_search_res = this.search_auxiliary(pops_search_res,TextField1Text_NoTone_arr[j]);
    }
    search_E = new Date();

    for(let i=0; i<pops_search_res.length; ++i){
      pops_search_res[i]["index"] = i+1;
    }

    if(api.print_logs){console.log(methName+"parserObject_categoriesCompaniesList.length = "+parserObject_categoriesCompaniesList.length);}
    if(api.print_logs){console.log(methName+"pops_search_res.length                      = "+pops_search_res.length);}
    if(api.print_logs){console.log(methName+"START                                       = "+search_S);}
    if(api.print_logs){console.log(methName+"END                                         = "+search_E);}
    if(pops_search_res.length===0){
        this.dialog_handleOpen(this.NSInforString("BillsSearch_msg02"));
    }
    else{
      //if(api.print_logs){console.log(methName+"pops_search_res = "+JSON.stringify(pops_search_res));}
      this.setState({
        "searchResults_isHidden" : false,
        "searchResults_arr"      : pops_search_res,
      });
    }

    if(keyword.startsWith("RF")===false){
      let tagManagerData = {
        'event'      : 'search_bills',
        'searchTerm' : searchTerm
      };
      //TagManager.dataLayer(tagManagerData);
      try { window.dataLayer.push(tagManagerData);                }catch(err1){console.log(methName+"err1="+err1);}
      try { console.log(methName+JSON.stringify(tagManagerData)); }catch(err2){console.log(methName+"err2="+err2);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  search_auxiliary(local_parserObject_categoriesCompaniesList,TextField1Text){
    let methName = filename+"search_auxiliary ";
    if(api.print_logs){console.log(methName);}

    let pops_search_res = [];

    let bill_id = 0;
    //----------
    let bpKeywords = "";
    let nameEl     = "";
    let nameEn     = "";
    //----------
    let bpKeywords_Index = -1;
    let nameEl_Index     = -1;
    let nameEn_Index     = -1;
    //----------
    let       isNotSearchResult = true;
    let       MAXRESULTS        = 750;
    let       foundResults      = 0;
    let TextField1Text_NoTone   = wu_Utilities.replaceTonoumena(TextField1Text.trim().toUpperCase());

    let aRow = null;
    let cnt = local_parserObject_categoriesCompaniesList.length;
    if(api.print_logs){console.log(methName+"cnt                    = "+cnt);}
    if(api.print_logs){console.log(methName+"Search START           = "+new Date());}
    for (let i=0; i<cnt; ++i) {
        aRow = local_parserObject_categoriesCompaniesList[i];
        isNotSearchResult = true;
        bpKeywords_Index  = -1;
        nameEl_Index      = -1;
        nameEn_Index      = -1;

        if(foundResults===MAXRESULTS){
            break;
        }
        try { bill_id = aRow["id"]; }catch(err){ bill_id = 0; }

        try { bpKeywords = aRow["bpKeywords"]; }catch(err){ bpKeywords = ""; } if(bpKeywords === null){bpKeywords = "";}
        try { nameEl     = aRow["nameEl"];     }catch(err){ nameEl     = ""; } if(nameEl     === null){nameEl     = "";}
        try { nameEn     = aRow["nameEn"];     }catch(err){ nameEn     = ""; } if(nameEn     === null){nameEn     = "";}

        bpKeywords_Index = wu_Utilities.replaceTonoumena(bpKeywords.toUpperCase()).indexOf(TextField1Text_NoTone);
        nameEl_Index     = wu_Utilities.replaceTonoumena(nameEl.toUpperCase()).indexOf(TextField1Text_NoTone);
        nameEn_Index     = wu_Utilities.replaceTonoumena(nameEn.toUpperCase()).indexOf(TextField1Text_NoTone);

        if (bpKeywords_Index !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")bpKeywords ="+bpKeywords);} }
        if (nameEl_Index     !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")nameEl     ="+nameEl);} }
        if (nameEn_Index     !== -1 && isNotSearchResult===true){ isNotSearchResult = false; if(api.print_logs){console.log("("+i+")nameEn     ="+nameEn);} }

        let already_exists = this.itemAlreadyExistsInArray(pops_search_res,bill_id);
        if(already_exists===true){
            isNotSearchResult = true;
        }
        if(api.bills_exclude_flags_enabled===true && wu_Utilities.bills_shouldBeInCategoriesListing(aRow)===false){isNotSearchResult = true;}
        if(isNotSearchResult===false){
            aRow = null;
            try { aRow = local_parserObject_categoriesCompaniesList[i]; } catch(err){;}
            pops_search_res.push(aRow);
            foundResults = foundResults +1;
        }
    }
    //pops_search_res.sort((a,b) => (a.distance > b.distance) ? 1 : ((b.distance > a.distance) ? -1 : 0));

    if(api.print_logs){console.log(methName+"Search END             = ",new Date());}
    if(api.print_logs){console.log(methName+"pops_search_res.length = "+pops_search_res.length);}
    return pops_search_res;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  itemAlreadyExistsInArray(searchArr,bill_id_search){
      if(bill_id_search===0){
          return false;
      }
      let bill_id = 0;
      let aRow = null;
      let cnt = searchArr.length;
      for(let i=0; i<cnt; ++i){
          aRow = searchArr[i];
          try { bill_id = aRow["id"]; }catch(err){ bill_id = 0; }
          if(bill_id===bill_id_search){
              return true;
          }
      }
      return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
}
BillsCompanies.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(BillsCompaniesStyle)(BillsCompanies)
);
